import { DiffModeType } from "types/WorkbookDiff";
import { makeStateContext } from "utils/context";

export const [DiffProvider, useDiffMode, useSetDiffMode] =
  makeStateContext<DiffModeType>();
